import { useQuery } from "@tanstack/react-query";
import { inboxApi } from "./api";
import { inboxKeys } from "./hooks";
import { useInboxToken } from "./useInboxToken";

const POLL_INTERVAL_MS = 60_000;

export const useUnreadConversationsCount = (enabled = true) => {
  const { accessToken } = useInboxToken();

  const query = useQuery({
    queryKey: inboxKeys.unreadConversationsCount(),
    queryFn: () => inboxApi.getUnreadConversationsCount(),
    enabled: enabled && !!accessToken,
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    retry: 1
  });

  return {
    ...query,
    unreadConversations: query.data?.unread_conversations ?? 0
  };
};
